import { render, staticRenderFns } from "./text-numeric-preview.vue?vue&type=template&id=a0a6544e&scoped=true&"
import script from "./text-numeric-preview.vue?vue&type=script&lang=js&"
export * from "./text-numeric-preview.vue?vue&type=script&lang=js&"
import style0 from "./text-numeric-preview.vue?vue&type=style&index=0&id=a0a6544e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a6544e",
  null
  
)

component.options.__file = "text-numeric-preview.vue"
export default component.exports